import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {

  @Input() public discardConfirmDialog: boolean = false;
  @Output() public hideConfirmModal = new EventEmitter<boolean>();

  public cancelDiscard() {
    this.discardConfirmDialog = false;
    this.hideConfirmModal.emit(true);
  }

  public discardConfirm() {
    this.discardConfirmDialog = false;
    this.hideConfirmModal.emit(false);
  }
}
